import React,{useEffect, useState} from 'react'
import './style.css'
import data from '../../../constant/data.json';
import FocusCard from '../../../components/main/FocusCard';
import { useParallax,Parallax } from 'react-scroll-parallax';

  
export default function FocusSection(props) {
      const [positionY,setPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    console.log(position)
    setPosition(position);
};
const [scrollProgress,setScrollProgress] = useState(0);

// const parallaxBack = useParallax({
//   speed: -60,
// });
useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);
    return (
     
        <div 
        // style={{
        //   position:"fixed"
        // }}
        
        className='focus-sec-main'>
          <div
          style={{
            // position:positionY > 2725? "fixed":"absolute",
            // top:positionY > 2725?200:0
            position:positionY > 5375? 'fixed':'sticky',
            top:210,
            marginBottom:100
          }}
          className='focus-text-con'>
            <p className='focus-header-text'>SERVICES</p>
            <p className='focus-content-header-text'>FOCUS AREAS</p>
            <p className='focus-content-text'>{data.focusarea1}</p>
            <p className='focus-content-text'>{data.focusarea2}</p>
            <img src={require("../../../assets/images/yesican.png")} className='focus-img-yesican' />
          </div>
          {/* <div style={{
            width:"100%",
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
          }}  ref={parallaxBack.ref}> */}
          <div style={{
            // backgroundColor:"red",
            width:'100vw',
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            top:0
          }}>

          {data.focus.map((item,index) =>{

            return (
            <FocusCard
                title={item.title}
                content={item.content}
                id={item.id}
                icon={item.icon}
                // top={positionY > 3525 + (index * 500)? 50 + (index * 100):650 + (index * 600)}
                top={ (50+(index * 100))}
                marginLeft={item.left}
                fix={positionY > 5375 && positionY < 7375  }
                bg={item.bg}
              />
            )
            })}
          </div>
         
         {/* </div> */}
           
        </div>
    )
}
